import $ from "jquery";

jQuery(function () {
  // Text scaling ///////////////////////////////////
  // When escape key is press, fade out text scaling menu
  function closeTextScalingMenu(e) {
    // console.log("e.key", e.key);

    if (e.key === "Escape") {
      closeTextScalingMenuForReal();
    }
  }

  // Fade out text scaling menu
  function closeTextScalingMenuForReal() {
    // $('#text-scaling-menu').attr('aria-expanded', false);
    $("#button-lettergrootte").attr("aria-expanded", false);
    $("#text-scaling-menu").fadeOut();
    document.removeEventListener("keyup", closeTextScalingMenu);
  }

  $("#hover-lettergrootte, #button-lettergrootte").on(
    "mouseenter click",
    function () {
      $("#button-lettergrootte").attr("aria-expanded", true);
      // $('#text-scaling-menu').attr('aria-expanded', true);
      $("#text-scaling-menu").fadeIn();
      document.addEventListener("keyup", closeTextScalingMenu);
    }
  );

  $("#text-scaling-menu").on("mouseleave", function () {
    closeTextScalingMenuForReal();
  });

  $("#hover-lettergrootte").on("keyup", function (e) {
    if (e.key === "Escape") {
      // $('#text-scaling-menu').attr('aria-expanded', false);
      $("#button-lettergrootte").attr("aria-expanded", false);
      $("#text-scaling-menu").fadeOut();
    }
  });

  const scaleSize = localStorage.scaleText;
  const textScaleSizes = ["100", "150", "200"];

  $(".toggle-scale-text").removeClass("active");

  textScaleSizes.forEach((size) => {
    document.documentElement.classList.remove(`scale-text-${size}`);
  });

  document.documentElement.classList.add(`scale-text-${scaleSize}`);

  $(`.toggle-scale-text[data-scale-text='${scaleSize}']`).addClass("active");

  $(".toggle-scale-text").on("click", function (e) {
    e.preventDefault();
    const elm = $(this);
    const scaleSize = elm.data("scale-text");

    $(".toggle-scale-text").removeClass("active");

    textScaleSizes.forEach((size) => {
      document.documentElement.classList.remove(`scale-text-${size}`);
    });

    document.documentElement.classList.add(`scale-text-${scaleSize}`);
    localStorage.scaleText = scaleSize;

    $(`.toggle-scale-text[data-scale-text='${scaleSize}']`).addClass("active");

    if (mobilePanel.hasClass("active")) {
      closeMobileMenu();
    }
    // $("body").removeClass("freeze");
  });

  // Text scaling END ///////////////////////////////////

  // Google Translate ///////////////////////////////////
  function closeTranslateMenu(e) {
    // console.log("e.key", e.key);

    if (e.key === "Escape") {
      $(".button-close-translate").trigger("click");
    }
  }

  $(".button-open-translate").on("click", function (e) {
    e.preventDefault();
    $(this).attr("aria-pressed", true);
    $(this).attr("aria-expanded", true);
    $(this).siblings(".translate-menu").show();

    document.addEventListener("keyup", closeTranslateMenu);
  });

  $(".button-close-translate").on("click", function () {
    $(".button-open-translate").attr("aria-pressed", false);
    $(".button-open-translate").attr("aria-expanded", false);
    $(this).parents(".translate-menu").hide();

    document.removeEventListener("keyup", closeTranslateMenu);
  });

  $(".translate-menu").on("keyup", function (e) {
    if (e.key === "Escape") {
      $(".translate-menu").hide();
    }
  });

  $(window).on("resize", function () {
    let myTimeout;

    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );

    clearTimeout(myTimeout);

    myTimeout = setTimeout(() => {
      if (vw > 768) {
        $("#google_translate_element").appendTo("#translate-container-desktop");
      } else {
        $("#google_translate_element").appendTo("#translate-container-mobile");
      }
    }, 500);
  });

  $(window).resize();
  // Google Translate END ///////////////////////////////////
});
